export default "__VITE_ASSET__DJb9iRBN__"